var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPcAccountIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2227_46477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 33,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 33,
    height: 33,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2227_46477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18.0762C19.1766 18.0762 18.0437 17.605 17.1013 16.6627C16.1588 15.7201 15.6875 14.5871 15.6875 13.2637C15.6875 11.9402 16.1588 10.8073 17.1013 9.86502C18.0437 8.92245 19.1766 8.45117 20.5 8.45117C21.8234 8.45117 22.9563 8.92245 23.8987 9.86502C24.8412 10.8073 25.3125 11.9402 25.3125 13.2637C25.3125 14.5871 24.8412 15.7201 23.8987 16.6627C22.9563 17.605 21.8234 18.0762 20.5 18.0762ZM10.1875 28.5475V25.4905C10.1875 24.8172 10.3704 24.1937 10.7361 23.6198C11.1019 23.046 11.5907 22.6048 12.2026 22.2964C13.5615 21.6302 14.9325 21.1305 16.3155 20.7973C17.6986 20.4641 19.0934 20.2975 20.5 20.2975C21.9066 20.2975 23.3014 20.4641 24.6845 20.7973C26.0675 21.1305 27.4385 21.6302 28.7974 22.2964C29.4093 22.6048 29.8981 23.046 30.2639 23.6198C30.6296 24.1937 30.8125 24.8172 30.8125 25.4905V28.5475H10.1875ZM12.25 26.485H28.75V25.4905C28.75 25.2121 28.6693 24.9543 28.508 24.7171C28.3467 24.4801 28.1277 24.2867 27.8511 24.1368C26.6663 23.5534 25.4584 23.1113 24.2273 22.8106C22.996 22.5102 21.7535 22.36 20.5 22.36C19.2465 22.36 18.004 22.5102 16.7727 22.8106C15.5416 23.1113 14.3337 23.5534 13.1489 24.1368C12.8723 24.2867 12.6533 24.4801 12.492 24.7171C12.3307 24.9543 12.25 25.2121 12.25 25.4905V26.485ZM20.5 16.0137C21.2563 16.0137 21.9036 15.7444 22.4422 15.2059C22.9807 14.6673 23.25 14.0199 23.25 13.2637C23.25 12.5074 22.9807 11.86 22.4422 11.3215C21.9036 10.7829 21.2563 10.5137 20.5 10.5137C19.7437 10.5137 19.0964 10.7829 18.5578 11.3215C18.0193 11.86 17.75 12.5074 17.75 13.2637C17.75 14.0199 18.0193 14.6673 18.5578 15.2059C19.0964 15.7444 19.7437 16.0137 20.5 16.0137Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcAccountIcon);
export default __webpack_public_path__ + "static/media/pc_account_icon.7f928d91a6fb741f11dd78a072f73b33.svg";
export { ForwardRef as ReactComponent };